export default class FormFieldErrors {
  constructor() {
    this.errors = {};
  }

  getError(path) {
    try {
      return eval(`this.errors.${path}`)[0];
    } catch (e) {
      return null;
    }
  }
  setError(data) {
    this.errors = data;
  }
}
